// extracted by mini-css-extract-plugin
export default {"header":"MenuHeader_header__7Lb0j"};